export default {
    pages: {
        index: 'Liste des pages',
        title: 'Titre',
        html: 'Contenu HTML',
        view: 'Voir une page <span class="text-caption text-medium-emphasis">{title}</span>',
        edit: 'Modifier une page <span class="text-caption text-medium-emphasis">{title}</span>',
        toaster: {
            PUT: {
                success: {
                    text: 'La page {title} a bien été mise à jour',
                    title: 'Pages',
                },
            },
        },
    },
    demandesacces: {
        application: {
            title: 'Application',
        },
        credentials: {
            created_at: 'Date de la demande',
        },
        custom_column: 'Gestion des droits',
        index: 'Liste des demandes d\'accès',
        response: {
            deny: 'Aucun accès',
            manage: 'Gestion',
            read: 'Lecture',
            write: 'Écriture',
        },
        text: 'Motivation',
        toaster: {
            PUT: {
                success: {
                    text: 'La demande d\'accès a été traitée',
                    title: 'Demande d\'accès',
                },
            },
        },
        user: {
            name: 'Utilisateur',
        },
    },
    structures: {
        add: 'Créer une structure',
        communes: {
            insee: 'Commune',
        },
        communes_count: 'Communes',
        delete: {
            index: 'Supprimer une structure',
            text: 'Souhaitez-vous vraiment supprimer la structure "{name}" ? <br/> <ul class="pl-2 pt-2"> <li>La suppression est <b>irrévocable</b>.</li><li><b>Toutes les données</b> renseignées dans les applications seront supprimées.',
            title: 'Supprimer la structure <span class="text-caption text-medium-emphasis">{name}</span>',
        },
        id: 'id',
        edit: 'Modifier la structure <span class="text-caption text-medium-emphasis">{name}</span>',
        index: 'Liste des structures',
        name: 'Nom',
        toaster: {
            POST: {
                success: {
                    text: 'La structure {name} a bien été créé',
                    title: 'Structures',
                },
            },
            PUT: {
                success: {
                    text: 'La structure {name} a bien été mise à jour',
                    title: 'Structures',
                },
            },
            DELETE: {
                success: {
                    text: 'La structure a bien été supprimée',
                    title: 'Structure supprimée',
                },
            },
        },
        type: {
            AUTRE: 'Autre',
            COMMUNE: 'Commune',
            DEPARTEMENT: 'Département',
            EPCI: 'EPCI',
            PRIVE: 'Privé',
            SYNDICAT: 'Syndicat',
            index: 'Type',
        },
        users: {
            id: 'Utilisateur',
        },
        users_count: 'Utilisateurs',

        view: 'Visualiser la structure <span class="text-caption text-medium-emphasis">{name}</span>',
    },
    utilisateurs: {
        add: 'Ajouter un utilisateur',
        application_roles_count: 'Applications',
        having_application_access: 'Application',
        credentials: {
            created_at: 'Compte créé le',
            updated_by: {
                name: 'Modifié par',
            },
        },
        delete: {
            index: 'Supprimer l\'utilisateur',
            text: 'Souhaitez-vous vraiment supprimer l\'utilisateur "{name}" ? <br/> <ul class="pl-2 pt-2"> <li>La suppression est <b>irrévocable</b>.</li><li><b>Toutes les données</b> renseignées par l\'utilisateur dans les applications seront anonymisées.',
            title: 'Supprimer un utilisateur <span class="text-caption text-medium-emphasis">{name}</span>',
        },
        edit: 'Modifier un utilisateur <span class="text-caption text-medium-emphasis">{first_name} {last_name}</span>',

        export: 'Exporter les utilisateurs',
        has_trashed: {
            all: 'Tous les utilisateurs',
            false: 'Exclure les désactivés',
            index: 'Statut du compte',
            true: 'Seulement les désactivés',
        },
        index: 'Liste des utilisateurs',
        last_connexion: 'Dernière connexion',
        name: 'Nom',
        restore: 'Activer',
        toaster: {
            DELETE: {
                success: {
                    text: 'L\'utilisateur {name} a bien été désactivé',
                    title: 'Utilisateur désactivé',
                },
            },
            POST: {
                success: {
                    text: 'L\'utilisateur {name} a bien été créé',
                    title: 'Utilisateur sauvegardé',
                },
            },
            PUT: {
                success: {
                    text: 'L\'utilisateur {name} a bien été mis à jour',
                    title: 'Utilisateur sauvegardé',
                },
            },
        },
        view: 'Visualiser un utilisateur <span class="text-caption text-medium-emphasis">{first_name} {last_name}</span>',
        managed_organizations: 'Structures gérées',
        can_manage_all: 'Toutes les structures',
        updated_at: 'Date de modification',
    },
    applications: {
        index: 'Liste des applications',
        edit: 'Modifier l\'application',
        add: 'Ajouter une application',
        new: 'Créer une application',
        custom_column: 'Actions',
        title: 'Titre',
        cancelRedirect: 'Annuler',
        redirect: 'Valider',
        image: 'Image mise en avant',
        icon: 'Icône de l\'application',
        users_count: 'Utilisateurs',
        users: {
            id: 'Utilisateurs',
        },
        number: {
            order: 'Ordre',
            year: 'Millésime',
        },
        description: 'Description',
        html: 'Texte d\'accueil',
        slug: 'Identifiant unique d\'URL',
        show_in_portal: {
            index: 'Afficher dans Portail',
            true: 'Oui',
            false: 'Non',
            all: 'Toutes les applications',
        },
        access_requests_count: {
            index: 'Demandes en attente',
            true: 'Oui',
            false: 'Non',
            all: 'Toutes les demandes',
        },
        delete: {
            index: 'Supprimer l\'application',
            text: 'Souhaitez-vous vraiment supprimer l\'application "{title}" ? <br/> <ul class="pl-2 pt-2"> <li>La suppression est <b>irrévocable</b>.</li><li><b>Toutes les demandes d\'accès</b> seront <b>supprimées</b>.<li><b>Toutes les données</b>renseignées dans l\'application seront <b>supprimées</b>.',
            title: 'Supprimer une application <span class="text-caption text-medium-emphasis">{title}</span>',
        },
        last_connection: 'Dernière connexion',
        name: 'Préfixe des tables dans la base de donnée',
        order: 'Ordre',
        latitude_min: 'Latitude min',
        latitude_max: 'Latitude max',
        longitude_min: 'Longitude min',
        longitude_max: 'Longitude max',
        mapBbox: 'Emprise de la carte',
        status: {
            index: 'Statut',
            draft: 'Brouillon',
            down: 'Désactivée',
            up: 'Publiée',
            archived: 'Archivée',
        },
        toaster: {
            PUT: {
                success: {
                    text: 'L\'application {title} a bien été mise à jour',
                    title: 'Modification de l\'application sauvegardée',
                },
            },
            POST: {
                success: {
                    text: 'L\'application {title} a bien été mise à jour',
                    title: 'Modification de l\'application sauvegardée',
                },
            },
            DELETE: {
                success: {
                    text: 'L\'application {title} a été supprimée',
                    title: 'Suppression de l\'application : {title}',
                },
            },
        },
    },
    applicationTables: {
        index: 'Configuration',
        slug: 'Identifiant unique d\'URL',
        delete: {
            index: 'Supprimer la configuration de la table de l\'application',
            text: 'Souhaitez-vous vraiment supprimer la configuration de la table de l\'application "{title}" ? <br/> <ul class="pl-2 pt-2"> <li>La suppression est <b>irrévocable</b>.</li><li><b>Toutes les demandes d\'accès</b> seront <b>supprimées</b>.<li><b>Toutes les données</b>renseignées dans l\'application seront <b>supprimées</b>.',
            title: 'Supprimer une configuration de la table de l\'application <span class="text-caption text-medium-emphasis">{title}</span>',
        },
        AddColumn: 'Ajouter la colonne',
        edit: 'Modifier la Table',
        name: 'Nom de la table dans la base de donnée',
        title: 'Titre de la table dans l\'application',
        order: 'Ordre',
        otherSections: 'Autres sections',
        enable_comments: 'Commentaires',
        optionalColumnToDisplay: 'Colonnes à afficher',
        otherOptionalColumnToDisplay: 'Autres options',
        display_creation_date: 'Afficher date de création',
        display_modification_date: 'Afficher date de modification',
        display_organization: 'Afficher la structure',
        display_export_data: 'Export des données',
        geometry_subtype: {
            index: 'Type de géométrie',
            LineString: 'Ligne',
            Point: 'Point',
            Polygon: 'Polygon',
        },
        is_multiple: 'Multiple',
        is_not_created: 'La table d\'application {name} doit être créée',
        toaster: {
            PUT: {
                success: {
                    text: 'La table d\'application {name} a été mise à jour',
                    title: 'Modification de la table d\'application',
                },
            },
            POST: {
                success: {
                    text: 'La table d\'application {name} a été créée',
                    title: 'Création de la table d\'application',
                },
            },
            DELETE: {
                success: {
                    text: 'La table d\'application {name} a été supprimée',
                    title: 'Suppression de la table d\'application',
                },
            },
        },
        SchemaCreate: 'Table à créer',
    },
    vectorStyles: {
        symbologie: {
            index: 'Symbologie',
        },
        geometry_subtype: 'Type de symbole',
        from_resolution_text: 'A partir de',
        from_resolution: 'A partir de',
        by_category_field_name: 'Nom du champ par catégorie',
        by_category: {
            index: 'Par catégorie',
        },
        add: 'Valider',
        edit: 'Valider',
        style: {
            index: 'Style',
            fontSymbol: {
                index: 'Symbole',
                color: 'Couleur de l\'icône',
                fillColor: 'Couleur du fond',
                fontSize: 'Taille de l\'icône',
                form: 'Forme du fond',
                glyph: 'Icône',
                opacity: 'Opacité',
                radius: 'Taille du symbole',
                strokeColor: 'Couleur du contour',
                strokeWidth: 'Épaisseur du contour',
            },
            fill: {
                index: 'Remplissage',
                color: 'Couleur du fond',
                opacity: 'Opacité du fond',
            },
            stroke: {
                index: 'Contour',
                color: 'Couleur du contour',
                lineCap: 'Style des extrémités',
                lineJoin: 'Style des jonctions',
                miterLimit: 'Longueur des jonctions',
                width: 'Épaisseur du contour',
            },
        },
        toaster: {
            PUT: {
                success: {
                    text: 'La symbologie a été mise à jour',
                    title: 'Modification de la symbologie',
                },
            },
            POST: {
                success: {
                    text: 'La symbologie a été créée',
                    title: 'Création de la section de la symbologie',
                },
            },
            DELETE: {
                success: {
                    text: 'La symbologie a été supprimée',
                    title: 'Suppression de la section de la symbologie',
                },
            },
        },
    },
    applicationTableSections: {
        index: 'Section',
        delete: {
            index: 'Supprimer la section de la table de l\'application',
            text: 'Souhaitez-vous vraiment supprimer la section configuration de la table de l\'application "{title}" ? <br/> <ul class="pl-2 pt-2"> <li>La suppression est <b>irrévocable</b>.</li><li><b>Toutes les demandes d\'accès</b> seront <b>supprimées</b>.<li><b>Toutes les données</b>renseignées dans l\'application seront <b>supprimées</b>.',
            title: 'Supprimer une section de la table de l\'application <span class="text-caption text-medium-emphasis">{title}</span>',
        },
        title: 'Section',
        order: 'Ordre',
        toaster: {
            PUT: {
                success: {
                    text: 'La section table d\'application {name} a été mise à jour',
                    title: 'Modification de la table d\'application',
                },
            },
            POST: {
                success: {
                    text: 'La section de la table d\'application {name} a été créée',
                    title: 'Création de la section de la table d\'application',
                },
            },
            DELETE: {
                success: {
                    text: 'La section de la table d\'application {name} a été supprimée',
                    title: 'Suppression de la section de la table d\'application',
                },
            },
        },
    },
    applicationTableFields: {
        index: 'Champs',
        add: 'Ajouter le champ',
        edit: 'Modifier le champ',
        title: 'Nom',
        name: 'Nom de champ',
        order: 'Ordre',
        common: 'Général',
        settings: 'Paramètres',
        field_type: {
            index: 'Type',
            SimpleText: 'Texte',
            CheckBox: 'Choix multiple',
            Select: 'Liste déroulante',
            FieldTable: 'Table liée',
            Date: 'Date',
        },
        description: 'Description additionnelle',
        rules: {
            index: 'Règles de validation',
            required: 'Champ obligatoire',
            min: 'Longueur minimale',
            max: 'Longueur maximale',
        },
        number: {
            rules_min: 'Valeur minimale',
            rules_max: 'Valeur maximale',
            rules_increment: 'Incrémentation',
        },
        rules_min: 'Longueur minimale',
        rules_max: 'Longueur maximale',
        rules_required: 'Champ obligatoire',
        rules_date_ranges: 'Plage de dates',
        rules_has_hour_minute: 'Inclure les heures et les minutes',
        rules_is_true_color: 'Couleur si cochée',
        rules_is_false_color: 'Couleur si non cochée',
        rules_is_tag: 'Affichage Tag',
        rules_multiple: 'Permettre de sélectionner plusieurs éléments à la fois',
        rules_options: 'Options',
        rules_file_type: 'Type de fichier',
        rules_field_table: 'Champ table liée',
        display_in_index: 'Afficher dans la liste',
        display_filter: 'Filtrable',
        quick_field: 'Afficher en info rapide',
        rules_increment: 'Incrémentation',
        toaster: {
            PUT: {
                success: {
                    text: 'La section table d\'application {name} a été mise à jour',
                    title: 'Modification de la table d\'application',
                },
            },
            POST: {
                success: {
                    text: 'La section de la table d\'application {name} a été créée',
                    title: 'Création de la section de la table d\'application',
                },
            },
            DELETE: {
                success: {
                    text: 'La section de la table d\'application {name} a été supprimée',
                    title: 'Suppression de la section de la table d\'application',
                },
            },
        },
    },
    applicationLayers: {
        index: 'Couche de cartes',
        name: 'Nom',
        title: 'Titre',
        toaster: {
            PUT: {
                success: {
                    text: 'La couche {name} a été mise à jour',
                    title: 'Modification des couches de carte de l\'application',
                },
            },
            POST: {
                success: {
                    text: 'La couche {name} a été ajouté à l\'application',
                    title: 'Modification des couches de carte de l\'application',
                },
            },
            DELETE: {
                success: {
                    text: 'La couche a été retiré de l\'application',
                    title: 'Suppression de la couche de l\'application',
                },
            },
        },
    },
    couchescartographiques: {
        index: 'Liste des couches cartographiques',
        add: 'Ajouter une couche cartographique',
        view: 'Voir une couche cartographique {layer_type}',
        edit: 'Modifier une couche cartographique {layer_type}',
        delete: {
            index: 'Supprimer une couche cartographique',
            text: 'Souhaitez-vous vraiment supprimer la couche "{name}" ?',
            title: 'Supprimer la couche <span class="text-caption text-medium-emphasis">{name}</span>',
        },
        new: 'Ajouter une couche cartographique',
        formulaire: {
            nouveau: 'Ajouter une couche cartographique',
        },
        layer_type: {
            index: 'Type de couche',
            xyz: 'xyz',
            MapServiceLayer: 'Service cartographique',
        },
        name: 'Nom',
        title: 'Titre',
        abstract: 'Description',
        url: 'Url',
        legend_url: 'Légende URL',
        attribution: 'Attribution',
        map_service_id: 'Service cartographique',
        service: {
            index: 'Service cartographique',
            title: 'Titre du service cartographique',
        },
        toaster: {
            DELETE: {
                success: {
                    text: 'La couche {name} a bien été supprimée',
                    title: 'Couche cartographique supprimée',
                },
            },
            POST: {
                success: {
                    text: 'La couche {name} a bien été créée',
                    title: 'Couche cartographique sauvegardée',
                },
            },
            PUT: {
                success: {
                    text: 'La couche {name} a bien été mise à jour',
                    title: 'Couche cartographique sauvegardée',
                },
            },
        },
    },
    servicescartographiques: {
        index: 'Liste des services cartographiques',
        add: 'Ajouter un service cartographique',
        view: 'Voir un service cartographique {service_type}',
        edit: 'Modifier un service cartographique {service_type}',
        delete: {
            index: 'Supprimer un service',
            text: 'Souhaitez-vous vraiment supprimer le service "{name}" ?',
            title: 'Supprimer le service <span class="text-caption text-medium-emphasis">{name}</span>',
        },
        new: 'Ajouter un service cartographique',
        formulaire: {
            nouveau: 'Ajouter un service cartographique',
        },
        service_type: {
            index: 'Type de service',
            WMS: 'WMS',
            WMTS: 'WMTS',
        },
        name: 'Nom',
        title: 'Titre',
        abstract: 'Description',
        url: 'Url',
        activesLayersCount: 'Nombre de couches',
        layers: {
            index: 'Couches cartographiques',
            title: 'Titre',
            name: 'Nom',
            abstract: 'Description',
        },
        toaster: {
            DELETE: {
                success: {
                    text: 'Le service {name} a bien été supprimé',
                    title: 'Service supprimé',
                },
            },
            POST: {
                success: {
                    text: 'Le service {name} a bien été créé',
                    title: 'Service sauvegardé',
                },
            },
            PUT: {
                success: {
                    text: 'Le service {name} a bien été mise à jour',
                    title: 'Service sauvegardé',
                },
            },
        },
    },
    historique: {
        index: 'Historique',
        view: 'Évènement de l\'historique',
        log_name: {
            index: 'Catégorie',
            admin: 'administration',
            generic: 'application générique',
            voirie: 'voirie',
        },
        event: {
            index: 'Évènement',
            deleted: 'suppression',
            updated: 'modification',
            created: 'création',
        },
        description: 'Description',
        subject_type: {
            index: 'Type d\'objet',
            AppModelsApplication: 'Application',
            AppModelsOrganization: 'Structure',
            AppModelsCommune: 'Commune',
            AppModelsAccessRequest: 'Demande d\'accès',
            AppModelsApplicationLayer: 'Couche d\'application',
            AppModelsApplicationRole: 'Rôle d\'application',
            AppModelsApplicationTable: 'Table d\'application',
            AppModelsApplicationTableField: 'Champs d\'application',
            AppModelsApplicationTableSection: 'Section',
            AppModelsApplicationVectorStyle: 'Style vectoriel d\'application',
            AppModelsMapLayer: 'Couche cartographique',
            AppModelsMapService: 'Service cartographique',
            AppModelsComment: 'Commentaire',
            AppModelsFieldsTable: 'Table liée',
            AppModelsMagicModel: 'Objet générique',
            AppModelsPage: 'Page',
            AppModelsPivotsUserManagedOrganizationPivot: 'Affectation Manager - Structure',
            AppModelsPivotsCommuneOrganizationPivot: 'Affectation Commune - Structure',
            AppModelsUser: 'Utilisateur',
            PildomModulesVoirieModelsIntention: 'Voirie - Intention',
            PildomModulesVoirieModelsIntentionBuffer: 'Voirie - Buffer Intention',
            PildomModulesVoirieModelsIntentionsImport: 'Voirie - Importation d\'Intentions',
            PildomModulesVoirieModelsOpportunity: 'Voirie - Opportunité',
            PildomModulesVoirieModelsOpportunityProcessing: 'Voirie - Calcul d\'opportunité',
            PildomModulesVoirieModelsSession: 'Voirie - Session',
            PildomModulesVoirieModelsLike: 'Voirie - Avis',
            PildomModulesVoirieModelsComment: 'Voirie - Commentaire',
            PildomModulesMajicModelsCommand: 'Majic - Commande',
            PildomModulesMajicModelsPivotsCommuneCommandPivot: 'Majic - Commande-Commune',
        },
        subject_id: 'ID de l\'objet',
        subject: 'Objet',
        application_table: 'Application générique',
        generic_table_name: 'Nom de la table en BD',
        entity_uuid: 'UUID de l\'objet',
        properties: 'Modifications',
        user: {
            index: 'Utilisateur',
            name: 'Utilisateur',
        },
    },
    availableslayers: 'Liste des couches cartographiques',
    SimpleText: 'Texte',
    TextArea: 'Zone de texte',
    Url: 'URL',
    Email: 'Email',
    Phone: 'Téléphone',
    Number: 'Nombre',
    Date: 'Date',
    Select: 'Sélecteur',
    CheckBox: 'Case à cocher',
    Radio: 'Bouton radio',
    File: 'Fichier',
    FieldTable: 'Table liée',
}
